import { get } from "vuex-pathify";
import _ from "lodash";
import URL from "url-parse";

export default {
    computed: {
        isSignedIn: get("user/isSignedIn"),
        selectedBodyStyles: get("vehicleSearch/filters@bodyStyles"),
        distance: get("vehicleSearch/filters@distance"),
        transmissions: get("vehicleSearch/filters@transmissions"),
        paymentType: get("vehicleSearch/filters@paymentType"),
        pageable: get("vehicleSearch/pageable"),
        displayMode: get("vehicleSearch/view"),
        isListingsAvailable: function() {
            return this.vehicle.count > 0;
        },
        title() {
            return `${this.vehicle.year} ${this.vehicle.make} ${this.vehicle.model}`;
        },
        yearsDisplay() {
            if (this.vehicle.minYear !== this.vehicle.maxYear) {
                return "New";
            }

            return this.vehicle.minYear;
        },
        hasLowestPrice() {
            return !_.isNil(_.get(this.vehicle, "lowestPrice", null));
        },
        hasBiggestSavings() {
            const biggestSavings = _.get(this.vehicle, "biggestSavings", null);

            return !_.isNil(biggestSavings) && biggestSavings.value > 1;
        },
        hasLowestPayment() {
            return !_.isNil(_.get(this.vehicle, "lowestPayment", null));
        },
        buildAndPriceUrl() {
            return `/shop-by/make/${this.vehicle.make}/model/${this.vehicle.modelId}?core4=false`;
        },
        listingsUrl() {
            const url = new URL("/shop/new", true);
            const pageable = this.pageable;
            const view = this.displayMode;

            const filters = {
                makes: [this.vehicle.make],
                models: [this.vehicle.model],
                bodyStyles: this.selectedBodyStyles,
                minYear: this.vehicle.minYear,
                maxYear: this.vehicle.maxYear,
                distance: this.distance,
                transmissions: this.transmissions,
                paymentType: this.paymentType
            };

            url.query = {
                ...filters,
                sort: pageable.sort,
                view
            };

            return url.toString();
        }
    },
    methods: {
        gotoVehicleDetails() {
            window.location = `/shop/${this.vehicle.stockType.toLowerCase()}/${
                this.vehicle.id
            }`;
        },

        showListings() {
            window.location.href = this.listingsUrl;
        },

        goToBuildAndPrice() {
            window.location.href = this.buildAndPriceUrl;
        },

        hotSpotHandler() {
            if (this.isListingsAvailable) {
                this.showListings();
            } else if (this.isBuildandPriceAvailable) {
                this.goToBuildAndPrice();
            } else {
                console.log(
                    "Error in hotSpotHandler: No Build & Price or Listings found."
                );
            }
        }
    }
};
